// repository.ts
import { getApiClient } from '@mit/aws-vue';
import { TextApi } from '@/api/TextApi';

const textRepository = getApiClient(TextApi, 'text@v2');

export default textRepository;
